// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1gXjr","emails":"CreateEditClinics_emails__JFyMF","emailTagLabel":"CreateEditClinics_emailTagLabel__iogm6"};